import React, { Component } from 'react';

export default class Sign extends Component {
  constructor(props) {
    super(props);
    if (!props.controls || props.controls.length !== 1) return;
    this.state = {

    };
    this.model = props.viewModel.get(props.controls[0].cItemName);
  }
  componentDidMount() {
    this.model && this.model.addListener(this);
  }
  setListenerState(params) {
    this.setValue(params.value);
  }
  setValue(value) {
    this.setState({ image: value && value.icon });
  }
  render() {
    const { controls } = this.props;
    if (!controls || controls.length !== 1)
      return null;
    const { image } = this.state;
    if (!image)
      return null;
    return (
      <span className={`sign-status-${image}`} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/Sign.jsx